import { Vector2 } from 'three';
import { commonConstants } from '../const_params';
import { computePositionValueAndDirection } from './penalty-image-selection.alg.logic';

const { roiInflateRates, angleDiffVariantsArr } = commonConstants;

export const selectBestMatchImageByPenalty = (
  camera,
  meshes,
  view_direction,
  jawName,
  intersect,
  currentActiveJaw,
  images_meta_data
) => {
  // Part 1: compute general compliance coefficient
  const image = {
    img_idx: -1,
    image: null,
    selected2DPointOnImage: new Vector2(0, 0),
  };

  for (let index = 0; index < roiInflateRates.length; ++index) {
    for (let angleDiffVariants = 0; angleDiffVariants < angleDiffVariantsArr.length; angleDiffVariants++) {
      const selectedImage = selectBestMatch(
        camera,
        meshes,
        view_direction,
        jawName,
        intersect,
        currentActiveJaw,
        images_meta_data,
        roiInflateRates[index],
        angleDiffVariantsArr[angleDiffVariants]
      );

      if (selectedImage.img_idx === -1) continue;

      image.img_idx = selectedImage.img_idx;
      image.image = currentActiveJaw[selectedImage.img_idx];
      image.selected2DPointOnImage = selectedImage.selected2DPointOnImage;

      const isValidScore = selectedImage.penalty < 1;
      if (isValidScore) {
        return image;
      }
    }
  }

  return image;
};

const selectBestMatch = (
  camera,
  meshes,
  view_direction,
  jawName,
  intersect,
  currentActiveJaw,
  images_meta_data,
  roiInflateRate,
  maxAngleDiff
) => {
  let minImagePenalty = Number.MAX_VALUE;
  const selectedImage = { img_idx: -1, selected2DPointOnImage: new Vector2(0, 0) };

  for (let image_idx = 0; image_idx < currentActiveJaw.length; ++image_idx) {
    const positionValueAndDirection = computePositionValueAndDirection({
      camera,
      meshes,
      jawName,
      image_idx,
      intersect,
      view_direction,
      images_meta_data,
      max_angle_difference: maxAngleDiff,
      roiInflateRate,
    });

    if (!positionValueAndDirection) continue;

    if (positionValueAndDirection.penalty < minImagePenalty) {
      selectedImage.img_idx = positionValueAndDirection.img_idx;
      selectedImage.penalty = positionValueAndDirection.penalty;
      selectedImage.selected2DPointOnImage = positionValueAndDirection.selected2DPointOnImage;
      minImagePenalty = positionValueAndDirection.penalty;
    }
  }

  return selectedImage;
};
